import React from 'react';
import { Clock } from 'lucide-react';

export interface TimerStyle03Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
}

// Default timer display translations
const DEFAULT_TIMER_LABELS: Record<string, string> = {
  '0': '關閉',
  '1': '1h',
  '2': '2h',
  '3': '3h',
  '4': '4h',
  '5': '5h',
  '6': '6h',
  '7': '7h',
  '8': '8h',
  '9': '9h',
  '10': '10h',
  '11': '11h',
  '12': '12h'
};

/**
 * Timer Style 03 - Pills Layout
 * Horizontal pill buttons for timer selection
 */
export const Style03_Pills: React.FC<TimerStyle03Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '預約定時',
  labels = DEFAULT_TIMER_LABELS
}) => {
  const getTimerLabel = (timer: string): string => {
    return labels[timer] || `${timer}h`;
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-purple-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((timer) => {
          const isSelected = value === timer;
          return (
            <button
              key={timer}
              onClick={() => onChange(timer)}
              disabled={disabled || loading}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all ${
                isSelected
                  ? 'bg-purple-500 text-white shadow-lg shadow-purple-500/30'
                  : 'bg-slate-700/50 text-slate-300 hover:bg-slate-600 border border-slate-600'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : getTimerLabel(timer)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style03_Pills;
